module.exports = __webpack_public_path__ + "img/light-mud-decal-13.944e348c.png";